export class Message {
	datasource?: DataSource;
	content?: string;
	isBot?: boolean;
	isLoading?: boolean;
	refs?: DocumentReference[];
}

export class ClassAssistantMessage {
	isAssistant: boolean;
	text: string;
}

export class DataSource {
	description?: string;
	label?: string;
	link?: string;
	vectorDocumentId?: string;
}

export class DocumentReference{
	page?: number;
	citation?: string;
}
